// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__lXEcn","box":"style_box__Ao0mo","active":"style_active__AkjsR","title":"style_title__Yh7JY","item":"style_item__WaGTE"};